import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/lib/css-base'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

window.customElements.define('plugin-all-models', wrap(Vue, () => import('~root/src/components/AllModels.vue?shadow')))

window.customElements.define('plugin-all-stones', wrap(Vue, () => import('~root/src/components/AllStones.vue?shadow')))

window.customElements.define('plugin-generated-stones', wrap(Vue, () => import('~root/src/components/GeneratedStones.vue?shadow')))

window.customElements.define('plugin-stone', wrap(Vue, () => import('~root/src/components/Stone.vue?shadow')))